// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7367aa4a]::-webkit-scrollbar{width:7px}[data-v-7367aa4a]::-webkit-scrollbar-button{background:transparent;border-radius:4px}[data-v-7367aa4a]::-webkit-scrollbar-track-piece{background:transparent}[data-v-7367aa4a]::-webkit-scrollbar-thumb{border-radius:4px;background-color:rgba(0,0,0,.3);border:0 solid #708090}[data-v-7367aa4a]::-webkit-scrollbar-track{-webkit-box-shadow:transparent;box-shadow:transparent}", ""]);
// Exports
module.exports = exports;
